import React, { useRef, useCallback, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form as UForm } from '@unform/web';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { useToast } from 'hooks/toast';
import * as Yup from 'yup';
import typeInvolvement from 'utils/typeInvolvement';
import handcuffs from 'utils/handcuffs';
import typemarital from 'utils/typemarital';
import states from 'utils/states';
import Simple from 'components/Headers/Simple';
import { AiOutlineFileText } from 'react-icons/ai';
import { validateCpf } from 'utils';
import getValidationError from '../../../../utils/getValidationsErros';

/** hooks */
import { useHttp } from '../../../../hooks/http';
import {
  WrapperLabel, Select, Button, Input, InputMask, DatePicker,
} from '../../../../components/Forms';
import { UserFriends } from '../../../../styles/icons';
import {
  Container, GridButtons, WrapperBtnCancel, WrapperBtnSubmit, LineTitle, WrapperAddress, Title,
} from './styles';
import Layout from '../../../../components/Layout';

/** Options Select */

const StoreInvolved: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { httpPost, httpGet } = useHttp();
  const history = useHistory();
  const { addToast } = useToast();
  const bopmId = localStorage.getItem('bopmId');
  const [listCities, setListCities] = useState([]);
  const [notNumber, setnotNumber] = useState(false);

  const handleCity = useCallback((event: any) => {
    const cityId = event;
    async function loadDitricts(): Promise<any> {
      const { status, data } = await httpGet(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${cityId?.id}/municipios`);
      if (status === 200) {
        const municipioParsed = data
          .map((municipio: any) => ({
            value: municipio.nome,
            label: municipio.nome,
          }));
        setListCities(municipioParsed);
      }
    }
    loadDitricts();
  }, [httpGet]);

  const handleNotNumber = useCallback((event) => {
    const keyCode = (event.keyCode ? event.keyCode : event.which);
    if (keyCode > 47 && keyCode < 58) {
      event.preventDefault();
      setnotNumber(true);
    } else { setnotNumber(false); }
  }, []);

  const handleSubmit = useCallback(async (data: any) => {
    const _involved = {
      ...data,
      bopm_id: bopmId,
      type_involvement: data.type_involvement?.value,
      handcuffs: data.handcuffs?.value,
      name: data.name,
      birthday: data.birthday,
      gender: data.gender?.value,
      document_secondary: data.document_secondary,
      document: data.document,
      mather: data.mather,
      father: data.father,
      marital: data.marital?.value,
      street: data.street,
      number: data.number,
      neighborhood: data.neighborhood,
      complement: data.complement,
      city: data.city?.value,
      state: data.state?.value,
      situation: data.situation?.value,
    };

    try {
    formRef.current?.setErrors({});
    const schema = Yup.object().shape({

      type_involvement: Yup.string().required('Tipo de envolvimento é obrigatório'),
      handcuffs: Yup.string().required('Motivação é obrigatório'),
      name: Yup.string().required('Nome é obrigatório'),
      birthday: Yup.date().required('Data é obrigatório ou está errada'),
      gender: Yup.string().required('Gênero é obrigatório'),
      document_secondary: Yup.number().required('Identidade é obrigatório').typeError('Somente números').positive('Número positivo')
        .integer('Número Inteiro'),
      document: Yup.string().test('is-valid', 'Insira um CPF válido', (value) => validateCpf(value, true)).required('CPF é obrigatório'),
      mather: Yup.string().required('Mãe é obrigatório'),
      marital: Yup.string().required('Estado Civil é obrigatório'),
      street: Yup.string().required('Logradouro é obrigatório'),
      neighborhood: Yup.string().required('O bairro é obrigatório'),
      number: Yup.number().typeError('Número é obrigatório').positive('Número positivo').integer('Número Inteiro'),
      city: Yup.string().typeError('O Município é obrigatório'),
      state: Yup.string().required('Estado é obrigatório'),
      situation: Yup.string().typeError('Situação é obrigatório'),

    });
    await schema.validate(_involved, { abortEarly: false });

    const { status } = await httpPost('involveds', _involved);

    if (status === 200) {
      addToast({ title: 'Salvo com sucesso!', type: 'success' });
      history.push('/bopm/involveds/show');
    } else {
      addToast({ title: 'Não foi possível gravar!', type: 'error' });
    }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const erros = getValidationError(err);
        formRef.current?.setErrors(erros);
      }
    }
  }, [addToast, bopmId, history, httpPost]);

  const breadcrumbs = {
    icon: UserFriends,
    links: [{ path: '/bopm/step/1', title: 'Bopm/Envolvidos/Cadastrar' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Container>
        <Simple>
          <Title>
            <AiOutlineFileText />Cadastrar Envolvidos
          </Title>
        </Simple>
        <WrapperAddress>
          <Container>
            <UForm ref={formRef} onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <WrapperLabel label="Tipo de envolvimento" xs={12} md={6} sm={6}>
                  <Select
                    name="type_involvement"
                    options={typeInvolvement}
                  />
                </WrapperLabel>

                <WrapperLabel label="Motivo das algemas" xs={12} md={6} sm={6}>
                  <Select
                    name="handcuffs"
                    options={handcuffs}
                  />
                </WrapperLabel>

                <WrapperLabel label="Nome" xs={12} sm={6}>
                  <Input name="name" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Data de nascimento" xs={12} md={6} sm={6}>
                  <DatePicker
                    name="birthday"
                    dateFormat="dd/MM/yyyy"
                  />

                </WrapperLabel>

                <WrapperLabel label="Gênero" xs={12} md={6} sm={6}>
                  <Select
                    name="gender"
                    options={[
                      { value: 'MASCULINO', label: 'MASCULINO' },
                      { value: 'FEMININO', label: 'FEMININO' },
                    ]}
                  />
                </WrapperLabel>

                <WrapperLabel label="RG" xs={12} md={6} sm={6}>
                  <Input name="document_secondary" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="CPF" xs={12} md={6} sm={6}>
                  <InputMask
                    name="document"
                    mask="999.999.999-99"
                    style={{ textTransform: 'uppercase' }}
                  />
                </WrapperLabel>

                <WrapperLabel label="Mãe" xs={12} md={6} sm={6}>
                  <Input name="mather" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Pai" xs={12} md={6} sm={6}>
                  <Input name="father" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Estado civil" xs={12} md={3} sm={3}>
                  <Select
                    name="marital"
                    options={typemarital}
                  />
                </WrapperLabel>
                <WrapperLabel label="Situação" xs={12} md={3} sm={3}>
                  <Select
                    name="situation"
                    options={[
                      { value: 'PRESO', label: 'PRESO' },
                      { value: 'APREENDIDO', label: 'APREENDIDO' },
                      { value: 'LIBERADO', label: 'LIBERADO' },
                    ]}
                  />
                </WrapperLabel>

                <LineTitle>
                  Residência:
                </LineTitle>

                <WrapperLabel label={notNumber === false ? 'Logradouro' : 'Somente Letras'} style={notNumber === false ? { color: '#131212' } : { color: '#c20a0a' }} xs={12} md={6} sm={6}>
                  <Input name="street" style={{ textTransform: 'uppercase' }} onKeyPress={handleNotNumber} />
                </WrapperLabel>

                <WrapperLabel label="Número" xs={6} sm={3} md={3}>
                  <Input name="number" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Complemento" xs={6} sm={3} md={3}>
                  <Input name="complement" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Bairro" xs={12} sm={6} md={6}>
                  <Input name="neighborhood" placeholder="" style={{ textTransform: 'uppercase' }} />
                </WrapperLabel>

                <WrapperLabel label="Estado" xs={12} md={6} sm={6}>
                  <Select
                    name="state"
                    options={states}
                    onChange={handleCity}
                  />
                </WrapperLabel>

                <WrapperLabel label="Município" xs={12} md={6} sm={6}>
                  <Select
                    name="city"
                    options={listCities}
                  />
                </WrapperLabel>

              </Grid>
              <GridButtons>
                <WrapperBtnCancel>
                  <Button
                    type="button"
                    onClick={() => { history.push('/bopm/step/1'); }}
                  >
                    Cancelar
                  </Button>
                </WrapperBtnCancel>
                <WrapperBtnSubmit>
                  <Button
                    type="submit"
                  >
                    Salvar
                  </Button>
                </WrapperBtnSubmit>
              </GridButtons>
            </UForm>
          </Container>
        </WrapperAddress>
      </Container>
    </Layout>
  );
};

export default StoreInvolved;
